import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { AuthComponent } from './auth/auth.component';
import { LandingComponent } from './landing/landing.component';
import { AuthorizationComponent } from './authorization/authorization.component';
import { AuthorizationGuard } from './core/guard/authorization.guard';
import { AuthenticationGuard } from './core/guard/authentication.guard';
import { UserGuard } from './core/guard/user.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'apicloud'
  },
  {
    path: 'auth',
   // component: AuthComponent,
    canLoad: [UserGuard],
    children: [
      {
        path: 'session',
        component: AuthComponent,
        canLoad: [UserGuard]
      }
    ]
  },
  {
    path: 'apicloud',
    loadChildren: 'app/home/home.module#HomeModule',
    canLoad: [AuthenticationGuard]
  },
  {
    path: 'landing',
    component: LandingComponent,
  },
  {
    path: 'restrict/:message',
    component: AuthorizationComponent
  },
  {
    path: '**',
    redirectTo: 'restrict/nocontent'
  }
];

@NgModule({
   imports: [
    RouterModule.forRoot(
      routes ,
      {
        useHash: false
        // enableTracing: true
      }
    )
   ],
  exports: [ RouterModule ],
  providers: [AuthenticationGuard, UserGuard],
  declarations: []
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/app-routing.module.ts